module.exports = __webpack_public_path__ + "static/media/b-fr.dda4d37f.png";